import { UserPasswordInput } from "@/features/cryptography/";
export const PortfolioPasswordInput = (props: {
  prompt?: string;
  isLoading?: boolean;
}) => {
  return <>
      <UserPasswordInput {...props} data-sentry-element="UserPasswordInput" data-sentry-source-file="PortfolioPasswordInput.tsx" />
    </>;
};